import { createWorld as a, addEntity as h, removeEntity as p, entityExists as c, addComponent as f, removeComponent as d, hasComponent as g } from "bitecs";
import { toKebabCase as r } from "../utils/naming.js";
import { ConfigRegistry as y } from "./config.js";
import { setComponentFields as o } from "./utils.js";
import { Parent as l } from "./components.js";
import { TIME_CONSTANTS as n } from "./constants.js";
import { Scheduler as u } from "./scheduler.js";
import { createEntityFromRecipe as w } from "../recipes/parser.js";
class M {
  world;
  time;
  scheduler = new u();
  systems = /* @__PURE__ */ new Set();
  config = new y();
  headless = !1;
  recipes = /* @__PURE__ */ new Map();
  components = /* @__PURE__ */ new Map();
  plugins = [];
  entityNames = /* @__PURE__ */ new Map();
  isDisposed = !1;
  constructor(e) {
    this.world = a(), this.time = {
      deltaTime: 0,
      fixedDeltaTime: n.FIXED_TIMESTEP,
      elapsed: 0
    }, this.headless = e?.headless ?? !1, this.registerComponent("parent", l), this.registerRecipe({
      name: "entity",
      components: []
    });
  }
  registerPlugin(e) {
    if (this.plugins.push(e), e.components)
      for (const [t, s] of Object.entries(e.components))
        this.registerComponent(t, s);
    if (e.systems)
      for (const t of e.systems)
        this.registerSystem(t);
    if (e.recipes)
      for (const t of e.recipes)
        this.registerRecipe(t);
    e.config && this.registerConfig(e.config);
  }
  async initializePlugins() {
    for (const e of this.plugins)
      e.initialize && await e.initialize(this);
  }
  registerSystem(e) {
    this.systems.has(e) || this.systems.add(e);
  }
  registerRecipe(e) {
    this.recipes.set(e.name, e);
  }
  registerComponent(e, t) {
    const s = r(e);
    this.components.set(s, t);
  }
  registerConfig(e) {
    this.config.register(e);
  }
  getParser(e) {
    return this.config.getParser(e);
  }
  getRecipe(e) {
    return this.recipes.get(e);
  }
  getComponent(e) {
    return this.components.get(r(e));
  }
  hasRecipe(e) {
    return this.recipes.has(e);
  }
  getRecipeNames() {
    return new Set(this.recipes.keys());
  }
  getComponentNames() {
    return Array.from(this.components.keys());
  }
  setEntityName(e, t) {
    this.entityNames.set(e, t);
  }
  getEntityByName(e) {
    return this.entityNames.get(e) ?? null;
  }
  getEntityName(e) {
    for (const [t, s] of this.entityNames)
      if (s === e) return t;
  }
  getNamedEntities() {
    return new Map(this.entityNames);
  }
  getComponentName(e) {
    for (const [t, s] of this.components.entries())
      if (s === e)
        return t;
  }
  step(e = n.DEFAULT_DELTA) {
    this.checkDisposed(), this.scheduler.step(this, e);
  }
  createEntity() {
    return this.checkDisposed(), h(this.world);
  }
  destroyEntity(e) {
    this.checkDisposed(), p(this.world, e);
  }
  exists(e) {
    return c(this.world, e);
  }
  addComponent(e, t, s) {
    f(this.world, t, e);
    const i = this.getComponentName(t);
    if (i) {
      const m = this.config.getDefaults(i);
      o(t, e, m);
    }
    s && o(t, e, s);
  }
  removeComponent(e, t) {
    d(this.world, t, e);
  }
  hasComponent(e, t) {
    return g(this.world, t, e);
  }
  createFromRecipe(e, t = {}) {
    return w(this, e, t);
  }
  dispose() {
    if (this.isDisposed)
      throw new Error("[VibeGame] State already disposed");
    for (const e of this.systems)
      e.dispose?.(this);
    this.systems.clear(), this.isDisposed = !0;
  }
  checkDisposed() {
    if (this.isDisposed)
      throw new Error("[VibeGame] Cannot use disposed State");
  }
}
export {
  M as State
};
//# sourceMappingURL=state.js.map
